/*custom-carousel.js*/

document.querySelectorAll('.custom-carousel').forEach(carousel => {
  const slides = carousel.querySelectorAll('.carousel-slide');
  const track = carousel.querySelector('.carousel-track');
  const thumbnails = carousel.querySelectorAll('.carousel-thumbnail');
  const viewport = carousel.querySelector('.carousel-viewport');

  let current = 0;

  function update() {
    slides.forEach(slide => slide.classList.remove('active'));
    thumbnails.forEach(thumb => thumb.classList.remove('active'));

    slides[current].classList.add('active');
    thumbnails[current].classList.add('active');

    const offset =
      slides[current].offsetLeft -
      (viewport.offsetWidth / 2) +
      (slides[current].offsetWidth / 2);

    track.style.transform = `translateX(-${offset}px)`;

    /*
    thumbnails[current].scrollIntoView({
      behavior: 'smooth',
      block: 'nearest',
      inline: 'center'
    });
    */
  }

  carousel.querySelector('.next').addEventListener('click', () => {
    current = (current + 1) % slides.length;
    update();
  });

  carousel.querySelector('.prev').addEventListener('click', () => {
    current = (current - 1 + slides.length) % slides.length;
    update();
  });

  thumbnails.forEach((thumb, index) => {
    thumb.addEventListener('click', () => {
      current = index;
      update();
    });
  });

  update();
});